(function(){
"use strict";
var D=window.BBM_DATA;
var SIZES=D.sizes, FINS=D.finishes, P=D.p, QS=D.qtys;
var state={size:SIZES[3].id, finish:FINS[0].id, qty:500, art:null, zoom:100, safe:false};
var ROOT=document.getElementById('bbm');
var $=function(i){return ROOT.querySelector('#'+i.replace(/([^\w-])/g,'\\$1'))};
var money=function(n){return '$'+n.toFixed(2)};
var num=function(n){return n.toLocaleString('en-US')};
function S(id){return SIZES.filter(function(x){return x.id===id})[0]}
function cell(s,f){return (P[s]||{})[f]||null}
function qIndex(q){ var i=0; for(var k=0;k<QS.length;k++){ if(q>=QS[k]) i=k; } return i; }
function unitAt(s,f,q){ var c=cell(s,f); if(!c) return null; return c.u[qIndex(q)]; }

function buildGrid(el,items,name,sel,cb){
  el.innerHTML='';
  items.forEach(function(it){
    var lab=document.createElement('label'); lab.className='sw'; lab.title=it.label;
    var inp=document.createElement('input'); inp.type='radio'; inp.name=name; inp.value=it.id;
    inp.id='bbm-'+name+'_'+it.id; inp.checked=it.id===sel;
    var img=document.createElement('img'); img.src=it.img; img.alt=it.label; img.loading='lazy';
    var nm=document.createElement('span'); nm.className='nm'; nm.textContent=it.label;
    lab.appendChild(inp); lab.appendChild(img); lab.appendChild(nm);
    if(name==='size' && it.live===false){ var fl=document.createElement('span'); fl.className='flag'; fl.textContent='NEW'; lab.appendChild(fl); }
    if(name==='finish'){ var up=document.createElement('span'); up.className='up'; up.dataset.fin=it.id; lab.appendChild(up); }
    inp.addEventListener('change',function(){ cb(it.id) });
    el.appendChild(lab);
  });
}

function drawRuler(maxIn){
  var svg=$('bbm-ruler'), r=$('bbm-stage').getBoundingClientRect();
  var W=Math.round(r.width)||360, H=Math.round(r.height)||360;
  svg.setAttribute('viewBox','0 0 '+W+' '+H); svg.setAttribute('width',W); svg.setAttribute('height',H);
  var px=W/maxIn, s='';
  for(var i=0;i<=maxIn;i++){
    var x=i*px;
    s+='<line x1="'+x+'" y1="0" x2="'+x+'" y2="'+H+'" stroke="currentColor" stroke-width="1" opacity="0.16"/>';
    s+='<line x1="0" y1="'+x+'" x2="'+W+'" y2="'+x+'" stroke="currentColor" stroke-width="1" opacity="0.10"/>';
  }
  svg.innerHTML=s;
}

function renderPreview(){
  var s=S(state.size), face=$('bbm-face'), box=$('bbm-stage').getBoundingClientRect();
  var avail=(box.width||360)-48, MAX=6, ppi=avail/MAX;
  var w=s.w*ppi, h=s.h*ppi;
  if(s.shape==='diamond'){ var dd=Math.min(w,h)*0.72; w=dd; h=dd; }
  face.className='btnface '+s.shape;
  face.style.width=Math.max(w,26)+'px'; face.style.height=Math.max(h,26)+'px';
  var sf=$('bbm-safe');
  sf.className='safe '+((s.shape==='circle'||s.shape==='ellipse')?s.shape:'');
  sf.style.inset=Math.max(4,Math.min(w,h)*0.11)+'px'; sf.hidden=!state.safe;
  $('bbm-dimtext').textContent=s.w+' × '+s.h+' in'+(s.live===false?' · not yet listed':'');
  $('bbm-scalenote').textContent='to scale · 6 in = full width';
  var art=$('bbm-art');
  if(state.art){ art.style.backgroundImage='url('+state.art+')'; art.style.backgroundSize=state.zoom+'%'; $('bbm-ph2').hidden=true }
  else { art.style.backgroundImage='none'; $('bbm-ph2').hidden=false }
  drawRuler(MAX);
}

function renderPrice(){
  var c=cell(state.size,state.finish), q=state.qty;
  $('bbm-skutext').textContent=c?c.sku:'—';
  if(!c) return;
  var u=unitAt(state.size,state.finish,q);
  $('bbm-unit').textContent='$'+(u<1?u.toFixed(3).replace(/0$/,''):u.toFixed(2));
  $('bbm-total').textContent=money(u*q);
  $('bbm-totalsub').textContent=num(q)+' pcs';
  var p50=c.u[0], sv=Math.round((1-u/p50)*100);
  $('bbm-idx').textContent=(sv>0?sv+'%':'—');
  $('bbm-idxsub').textContent=(sv>0?'vs '+money(p50)+' at 50 pc':'smallest run');

  var w=$('bbm-warn');
  if(q<D.minQty){ w.hidden=false; w.textContent='Below the '+D.minQty+'-piece production minimum. '+D.minQty+' is the smallest run.' }
  else w.hidden=true;

  var i=qIndex(q), nxt=(i<QS.length-1)?QS[i+1]:null, n=$('bbm-nudge');
  if(nxt){
    var nu=unitAt(state.size,state.finish,nxt), nowT=u*q, thenT=nu*nxt, need=nxt-q;
    var msg='<span>Add <b>'+num(need)+'</b> more ('+num(nxt)+' total) and each button drops to <b>'+money(nu)+'</b>';
    msg += (thenT<nowT) ? ' — '+num(need)+' extra buttons and <b>'+money(nowT-thenT)+' less</b> overall.' : ', a total of '+money(thenT)+'.';
    n.hidden=false; n.innerHTML=msg+'</span><button type="button" id="bbm-jump">'+num(nxt)+'</button>';
    $('bbm-jump').addEventListener('click',function(){ state.qty=nxt; $('bbm-qty').value=nxt; renderAll() });
  } else n.hidden=true;

  var lad=$('bbm-ladder');
  lad.innerHTML='<div class="lrow head"><span>Quantity</span><span>Per unit</span><span>Order total</span><span>Save</span></div>';
  var top=c.u[0];
  QS.forEach(function(qq,k){
    var uu=c.u[k], sav=Math.round((1-uu/top)*100);
    var row=document.createElement('div');
    row.className='lrow clickable'+(k===i?' on':'');
    row.innerHTML='<span>'+num(qq)+'</span><span>'+money(uu)+'</span><span>'+money(uu*qq)+'</span><span class="sv">'+(sav>0?'−'+sav+'%':'—')+'</span>';
    row.addEventListener('click',function(){ state.qty=qq; $('bbm-qty').value=qq; renderAll() });
    lad.appendChild(row);
  });

  var stdU=unitAt(state.size,FINS[0].id,q);
  FINS.forEach(function(f){
    var el=ROOT.querySelector('.up[data-fin="'+f.id+'"]'); if(!el) return;
    var fu=unitAt(state.size,f.id,q), dd=fu-stdU;
    el.textContent = dd<=0.005 ? 'included' : '+'+money(dd);
    el.style.color = dd<=0.005 ? 'var(--good)' : 'var(--muted)';
  });
}

var sortKey='unit', sortDir=1;
function renderTable(){
  var shape=$('bbm-fshape').value, fin=$('bbm-ffin').value, q=parseInt($('bbm-fqty').value,10), live=$('bbm-flive').value;
  var rows=[];
  SIZES.forEach(function(s){
    if(shape && s.shape!==shape) return;
    if(live==='1' && s.live===false) return;
    if(live==='0' && s.live!==false) return;
    FINS.forEach(function(f){
      if(fin && f.id!==fin) return;
      var c=cell(s.id,f.id); if(!c) return;
      var k=qIndex(q);
      rows.push({size:s.label,finish:f.label,sku:c.sku,unit:c.u[k],total:c.u[k]*q,
                 save:1-c.u[k]/c.u[0],sid:s.id,fid:f.id,live:s.live});
    });
  });
  rows.sort(function(a,b){ var x=a[sortKey],y=b[sortKey];
    return typeof x==='string' ? sortDir*x.localeCompare(y) : sortDir*(x-y) });
  var min=Math.min.apply(null,rows.map(function(r){return r.unit}));
  var body=$('bbm-mtxbody'); body.innerHTML='';
  var frag=document.createDocumentFragment();
  rows.forEach(function(r){
    var tr=document.createElement('tr');
    if(r.sid===state.size&&r.fid===state.finish) tr.className='hit';
    tr.innerHTML='<td>'+r.size+(r.live===false?' <span style="color:var(--good)">•</span>':'')+'</td>'+
      '<td>'+r.finish+'</td><td class="sku">'+r.sku+'</td>'+
      '<td'+(r.unit===min?' class="cheap"':'')+'>'+money(r.unit)+'</td>'+
      '<td>'+money(r.total)+'</td>'+
      '<td class="sku">'+(r.save>0.001?'−'+Math.round(r.save*100)+'%':'—')+'</td>';
    tr.addEventListener('click',function(){
      state.size=r.sid; state.finish=r.fid;
      $('bbm-size_'+r.sid).checked=true; $('bbm-finish_'+r.fid).checked=true;
      renderAll(); ROOT.querySelector('.cols').scrollIntoView({behavior:'smooth',block:'start'});
    });
    frag.appendChild(tr);
  });
  body.appendChild(frag);
  $('bbm-mtxnote').textContent=rows.length+' variants at '+num(q)+' pieces. Green dot = shape not on the site today. Click any row to load it into the builder.';
}

function renderAll(){ renderPreview(); renderPrice(); renderTable() }

buildGrid($('bbm-sizegrid'),SIZES,'size',state.size,function(id){state.size=id; renderAll()});
buildGrid($('bbm-fingrid'),FINS,'finish',state.finish,function(id){state.finish=id; renderAll()});
$('bbm-sizecount').textContent=SIZES.length+' options · 8 new';
$('bbm-combocount').textContent=(SIZES.length*FINS.length)+' combinations';

var chips=$('bbm-qtychips');
[50,100,250,500,1000,2500,5000,10000].forEach(function(b){
  var c=document.createElement('button'); c.type='button'; c.className='chip'; c.textContent=num(b);
  c.addEventListener('click',function(){ state.qty=b; $('bbm-qty').value=b; renderAll() });
  chips.appendChild(c);
});
SIZES.map(function(s){return s.shape}).filter(function(v,i,a){return a.indexOf(v)===i}).forEach(function(sh){
  var o=document.createElement('option'); o.value=sh; o.textContent=sh.charAt(0).toUpperCase()+sh.slice(1); $('bbm-fshape').appendChild(o) });
FINS.forEach(function(f){ var o=document.createElement('option'); o.value=f.id; o.textContent=f.label; $('bbm-ffin').appendChild(o) });
QS.forEach(function(q){ var o=document.createElement('option'); o.value=q; o.textContent=num(q)+' pcs'; $('bbm-fqty').appendChild(o) });
$('bbm-fqty').value=500;

$('bbm-qty').addEventListener('input',function(){ var v=parseInt(this.value,10); state.qty=(isNaN(v)||v<1)?1:v; renderPrice(); renderTable() });
['bbm-fshape','bbm-ffin','bbm-fqty','bbm-flive'].forEach(function(id){ $(id).addEventListener('change',renderTable) });
ROOT.querySelectorAll('#bbm-mtx th').forEach(function(th){
  th.addEventListener('click',function(){ var k=th.dataset.k;
    if(sortKey===k) sortDir*=-1; else { sortKey=k; sortDir=1 } renderTable() }) });
$('bbm-showsel').addEventListener('click',function(){
  $('bbm-fshape').value=''; $('bbm-ffin').value=''; $('bbm-flive').value=''; renderTable();
  var h=ROOT.querySelector('#bbm-mtxbody tr.hit'); if(h) h.scrollIntoView({behavior:'smooth',block:'center'}) });

$('bbm-pick').addEventListener('click',function(){ $('bbm-file').click() });
$('bbm-file').addEventListener('change',function(e){
  var f=e.target.files&&e.target.files[0]; if(!f) return;
  var rd=new FileReader(); rd.onload=function(ev){ state.art=ev.target.result; renderPreview() }; rd.readAsDataURL(f) });
$('bbm-clear').addEventListener('click',function(){ state.art=null; $('bbm-file').value=''; state.zoom=100; $('bbm-zoom').value=100; renderPreview() });
$('bbm-toggleSafe').addEventListener('click',function(){ state.safe=!state.safe; this.textContent=state.safe?'Hide safe zone':'Safe zone'; renderPreview() });
$('bbm-zoom').addEventListener('input',function(){ state.zoom=parseInt(this.value,10); renderPreview() });
window.addEventListener('resize',renderPreview);
$('bbm-stamp').textContent='Built '+new Date().toISOString().slice(0,10)+' · live pricing preserved · internal preview';
renderAll();
})();